const dataConstants = {
  GET_MARITAL_STATUS: "GET_MARITAL_STATUS",
  GET_MOTHER_TONGUE: "GET_MOTHER_TONGUE",
  GET_COMPLEXION: "GET_COMPLEXION",
  GET_BODY_TYPE: "GET_BODY_TYPE",
  GET_DIET: "GET_DIET",
  GET_HABIT_TYPE: "GET_HABIT_TYPE",
  GET_JOB_TYPE: "GET_JOB_TYPE",
  GET_INCOME: "GET_INCOME",
  GET_EDUCATION: "GET_EDUCATION",
  GET_EMPLOYED_IN: "GET_EMPLOYED_IN",
  GET_RELIGION: "GET_RELIGION",
  GET_COMMUNITY_BY_RELIGION: "GET_COMMUNITY_BY_RELIGION",
  CREATE_COMMUNITY_BY_RELIGION: "CREATE_COMMUNITY_BY_RELIGION",
  GET_CASTE: "GET_CASTE",
  GET_HEIGHT: "GET_HEIGHT",
  GET_DISABILITY: "GET_DISABILITY",
  GET_FAMILY_STATUS: "GET_FAMILY_STATUS",
  GET_FAMILY_VALUE: "GET_FAMILY_VALUE",
  GET_FAMILY_TYPE: "GET_FAMILY_TYPE",
  GET_HOUSE_TYPE: "GET_HOUSE_TYPE",
  GET_MOON_SIGN: "GET_MOON_SIGN",
  GET_CREATED_BY: "GET_CREATED_BY",
  GET_COUNTRY: "GET_COUNTRY",
  GET_STATE_BY_COUNTRY: "GET_STATE_BY_COUNTRY"
};

export default dataConstants;



// WEBPACK FOOTER //
// ./src/_constants/dataConstants.js